import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class ColaboraMapaService {

    static colaboraMap(businessId, to, subject, content, esColaboratiu, content2){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.sendMailUrl, { 
            uid: uid, 
            token: token, 
            businessId: businessId, 
            to: to,
            subject: subject,
            content: content,
            esColaboratiu: esColaboratiu,
            content2: content2
        }).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

    static getConvidats(businessId){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.getConvidatsUrl, {uid: uid, token: token, businessId: businessId}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

    static eliminarConvidat(businessId, email){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.deleteConvidatUrl, {uid: uid, token: token, businessId: businessId, convidatEsborrar: email}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

    static eliminarConvidatByUid(businessId){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.deleteConvidatByUid, {uid: uid, token: token, businessId: businessId, convidatEsborrar: uid}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/perfil/components/colabora-modal/services/colaboraMapaService.js